<template>
  <div class="main">
    <div class="row">
      <span class="label">用户名</span>
      <a-input
        size="large"
        type="text"
        v-model="formLogin.username"
        placeholder="请输入用户名"
      >
      </a-input>
    </div>
    <div class="row">
      <span class="label">密码</span>
      <a-input
        size="large"
        type="password"
        v-model="formLogin.password"
        placeholder="请输入密码"
      >
      </a-input>
    </div>
    <div class="row">
      <a-button
        block
        size="large"
        type="primary"
        htmlType="submit"
        class="login-button"
        :loading="loading"
        @click="handleLoggin"
        :disabled="loading"
        >确定
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { timeFix } from "@/utils/util";

export default {
  data() {
    return {
      loading: false,
      formLogin: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions(["Login"]),
    handleLoggin() {
      if (!this.formLogin.username) {
        this.$message.error("用户名不能为空");
        return;
      }
      if (!this.formLogin.password) {
        this.$message.error("密码不能为空");
        return;
      }
      this.loading = true;
      this.Login(this.formLogin)
        .then(() => {
          this.loginSuccess();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    loginSuccess() {
      this.loading = false;
      this.$router.push({ name: "dashboard" });
      this.$message.success(timeFix() + "，欢迎回来", 3);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  .row {
    margin-top: 42px;
    width: 368px;
    .label {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: #414042;
      margin-bottom: 3px;
      padding-left: 21px;
    }
    input {
      border-radius: 20px;
    }
    button {
      border-radius: 20px;
    }
  }
}
</style>
